import { Link } from 'react-router-dom';
import Count from "../../common/count";
import image from "../../../assets/img/page/who-we-are.jpg";

const AboutTwo = () => {
    return (
        <div className="about__two section-padding pt-0">
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 col-lg-6 lg-mb-25">
                        <div className="about__two-left section-padding pb-0">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">About Our Company</span>
                            <h2 className="wow fadeInRight" data-wow-delay=".6s">Shaping the Future of Construction</h2>
                            <p className="wow fadeInUp" data-wow-delay=".4s">The Engineersbay Limited is a dynamic and forward-thinking company dedicated to excellence in engineering construction, supervision, consultancy, design, drawing, feasibility studies, architecture, material supply, IT and software development. With a strong presence in export, import, and marketing, we serve a diverse range of industries, ensuring high-quality solutions that drive innovation and sustainability.
                                At The Engineersbay Limited, we are more than just a service provider—we are partners in progress, dedicated to building a prosperous and sustainable future for our clients, stakeholders, and communities.
                            </p>
                            {/* <div className="wow fadeInDown" data-wow-delay="1.2s">
                                <Link className="build_button mt-35" to="/about-us">All Services<i className="flaticon-right-up"></i></Link>                        
                            </div> */}
                        </div>
                    </div>
                    <div className="col-xl-7 col-lg-6">
                        <div className="about__two-right">
                            <img className="wow img_top_animation" src={image} alt="image" />
                            <div className="counter__one-area mt-35">
                                <div className="about__two-right-counter">
                                    <h2><Count number={5}/>+</h2>
                                    <p>Complete Projects</p>
                                </div>
                                <div className="about__two-right-counter">
                                    <h2><Count number={60}/>+</h2>
                                    <p>Team Members</p>
                                </div>
                                <div className="about__two-right-counter">
                                    <h2><Count number={9}/>+</h2>
                                    <p>Running Projects</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutTwo;